import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../services/auth/auth.service';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

/**
 * Tela de Login
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../assets/css/auth.css']
})
export class LoginComponent implements OnInit {

  /** Indica se o conteúdo do campo de senha deve ser exibido ou não. */
  private passwordHidden: boolean = true;

  /** Indica se o spinner de carregamento deve ser exibido ou não. */
  private loading: boolean = false;

  /** Conteúdo da mensagem de erro de autenticação. */
  private errorMsg: string = '';

  /** Formgroup com campos de e-mail e senha. */
  loginForm = this.fb.group({
    'email': ['', [Validators.required, Validators.email]],
    'password': ['', Validators.required],
  });

  /**
   * Construtor
   * @param authService serviço com funções de autenticação.
   * @param fb form builder para os campos de autenticação.
   * @param router router para navegar após autenticação bem sucedida.
   */
  constructor(private authService: AuthService, private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {
  }

  /**
   * Acessa o serviço de autenticação para fazer login do usuário
   */
  login() {

    const { email, password } = this.loginForm.value;

    this.loading = true;
    this.errorMsg = '';

    this.authService.login(email, password)
      .pipe(
        finalize(() => {
          this.loading = false;
        }
      ))
      .subscribe(
        data => {
          this.authService.setUserInfo(data);
          this.router.navigate(['/sistema/dashboard']);
        }, err => {
          this.errorMsg = err;
        }
      );
  }

  /**
   * Alterna entre exibir e esconder o texto do campo de senha. 
   */
  togglePassword() {
    this.passwordHidden = !this.passwordHidden;
  }

}
